import { render, staticRenderFns } from "./CmgLeaderboardHeadbanner.vue?vue&type=template&id=37294098&scoped=true&lang=pug"
import script from "./cmg-leaderboard-headbanner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-headbanner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardHeadbanner.vue?vue&type=style&index=0&id=37294098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37294098",
  null
  
)

export default component.exports